/**
 * Each page names itself in the browser's tab and history (the user,
 * 2026-10-12: "pages don't have unique titles" — the history was twelve
 * "MyRave.io"). Most specific first, the platform last:
 * "Line-up · Imagine 22 · Rave Admin · MyRave.io". The title in
 * `index.html` stays the one before the app runs; leaving a page puts back
 * the one before it.
 */
import { useEffect } from 'react';

export const PLATFORM_TITLE = 'MyRave.io';

export function titleOf(parts: readonly (string | null | undefined | false)[]): string {
  return [...parts.filter((p): p is string => Boolean(p && p.trim())), PLATFORM_TITLE].join(' · ');
}

export function usePageTitle(parts: readonly (string | null | undefined | false)[]): void {
  const title = titleOf(parts);
  useEffect(() => {
    const before = document.title;
    document.title = title;
    return () => { document.title = before; };
  }, [title]);
}

/** The same, as an element — for a screen whose hooks cannot run after its early returns. */
export function PageTitle({ parts }: { parts: readonly (string | null | undefined | false)[] }) {
  usePageTitle(parts);
  return null;
}
